@if (inited) {
    <div class="height100p flex-col">
        <sm-toolbar class="flex-item-fixed">
            @if (!isPast) {
                <button pButton icon="fas fa-save" label="Speichern" [disabled]="!isChanged()" (click)="save()">
                </button>
            }
            <p-select class="width100" id="gradeLevel" [options]="gradeLevels"
                [(ngModel)]="selectedGradeLevel" (onChange)="gradeLevelChanged()">
            </p-select>
        </sm-toolbar>
        <sm-table class="flex-item-fill" [data]="table">
        </sm-table>
    </div>
}